export const FETCH_DELAY = 2000;

export const GROUPS_QUERY_KEY = 'groups';
